import { render } from "./BuzzingList.vue?vue&type=template&id=7eabdcfe"
import script from "./BuzzingList.vue?vue&type=script&lang=js"
export * from "./BuzzingList.vue?vue&type=script&lang=js"

import "./BuzzingList.vue?vue&type=style&index=0&id=7eabdcfe&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__